export default {
    id:                             '',
    schedule_id:                    '',
    name:                           '',
    phone_number:                   '',
    email:                          '',
    reward:                         '',
    court_name:                     '',
    bailiff_office_name:            'Komornik Sądowy przy Sądzie Rejonowym w',
    bailiff_office_address:         '',
    bailiff_office_house_number:    '',
    bailiff_office_flat_number:     '',
    bailiff_office_post_code:       '',
    bailiff_office_city:            '',
    guarantors:                     [],
    cases:                          [],
    telephones:                     []
}
